import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.415}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 137939 203564"
    {...props}
  >
    <path
      d="M101210 142902c-26741-3865-25670-18162-25670-18162v-7795c18357-680 39402-3431 62399-9801L98630 0H39309L0 107144s23751 9355 62398 9938v7661s1072 14297-25670 18159c-26738 3865-17647 38252-17647 38252s3512 22410 49888 22410c46377 0 49889-22410 49889-22410s9091-34390-17648-38252z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
